/**
 * Created by josh on 17/08/11.
 * 路由元信息 meta 字段
 * path: string;
 * component?: Component;
 * name?: string; // for named routes (命名路由)
 * components?: { [name: string]: Component }; // for named views (命名视图组件)
 * redirect?: string | Location | Function; //路由重定向
 * alias?: string | Array<string>; 别名
 * children?: Array<RouteConfig>; // for nested routes
 * beforeEnter?: (route: Route, redirect: Function, next: Function) => void; //路由钩子
 * meta?: any; //参数
 */
// 登录
// const home = resolve => require(['../views/home.vue'], resolve);
// const subRouter = resolve => require(['../components/router.vue'], resolve);

const subRouter = () =>
  import ('../components/subRouter.vue');

// 首页
const home = () =>
  import ('../views/home.vue');

// 联系人管理
const contacts = () =>
  import ('../views/user/contacts.vue');

// 流程签署
const signFlow = () =>
  import ('../views/sign/flow.vue');

const Signer = () =>
  import ('../views/sign/sign.vue');

// 我的合同
const word = () =>
  import ('../views/word/word.vue');
// 批量签署
const batch = () =>
  import('../views/word/batch.vue');
// 信息管理
const info = () =>
  import ('../views/user/info.vue');

// 印章管理
const seal = () =>
  import ('../views/user/seal.vue');
// 添加印章
const addSeal = () =>
  import ('../views/user/addSeal.vue');
// 编辑印章
const editSeal = () =>
  import ('../views/user/editSeal.vue');
// 合同模板编辑页面
const templateEdit = () =>
  import ('../views/template/templateEdit.vue');
// 我的模板
const myTemplate = () => import('../views/template/template.vue');
// 合同预览
const templatePreview = () =>
  import ('../views/template/templatePreview.vue');


export default [
  {
    path: 'index',
    name: 'Index',
    meta: {
      alias: '首页'
    },
    component: home
  },
  {
    path: 'word',
    name: 'Word',
    meta: {
      alias: '我的合同'
    },
    component: word
  },
  {
    path: 'template',
    name: 'Template',
    meta: {
      alias: '我的模板'
    },
    component: myTemplate
  },
  {
    path: 'user',
    meta: {
      alias: '用户中心'
    },
    component: subRouter,
    children: [
      // 默认
      {
        path: '',
        name: 'User',
        redirect: 'info' // 重定向到 info
      },
      {
        path: 'info',
        name: 'Info',
        meta: {
          alias: '信息管理'
        },
        component: info
      },
      {
        path: 'seal',
        name: 'Seal',
        meta: {
          alias: '印章管理'
        },
        component: seal
      },
      {
        path: 'addSeal',
        name: 'addSeal',
        component: addSeal
      },
      {
        path: 'editSeal',
        name: 'editSeal',
        component: editSeal
      },
      {
        path: 'contacts',
        name: 'Contacts',
        meta: {
          alias: '联系人管理'
        },
        component: contacts
      }
    ]
  },
  {
    path: 'flow',
    name: 'Flow',
    component: signFlow
  },
  // {
  //   path: 'flowback',
  //   name: 'Flowback',
  //   component: () => import ('../views/sign/flow-back.vue')
  // },
  {
    path: 'signer',
    name: 'Signer',
    component: Signer
  },
  {
    path: 'batch',
    name: 'Batch',
    meta: {
      alias: '批量签署'
    },
    component: batch
  },
  // {
  //   path: 'sign',
  //   meta: {},
  //   component: subRouter,
  //   children: []
  // },
  {
    path: 'templateEdit',
    name: 'TemplateEdit',
    component: templateEdit
  },
  {
    path: 'templatePreview',
    name: 'TemplatePreview',
    component: templatePreview
  }
];



// WEBPACK FOOTER //
// ./src/pages/admin/router/main.js